import { PageHeader} from '@ant-design/pro-layout';
import { NavigationMenu } from '../shared/navigation-menu';

export const LandingPageHeader = () => {
  return (
    <PageHeader title="" style={{ backgroundColor: 'red', padding: '0px' }}>
      <NavigationMenu />
    </PageHeader>
  )
}